module.exports = __webpack_public_path__ + "media/country_flags/np-22e576cb.png";